// src/core/common/modalHelpers.ts
declare global {
  interface Window { bootstrap?: any }
}

export const cleanupModals = () => {
  // Remove any bootstrap backdrops left behind
  document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
  // Unlock body
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("padding-right");
  document.body.style.removeProperty("overflow");
};

export const showModal = (id: string) => {
  const el = document.getElementById(id);
  if (!el) return;

  if (window.bootstrap?.Modal) {
    // ensure old artifacts are gone before opening a new one
    cleanupModals();
    const inst = window.bootstrap.Modal.getOrCreateInstance(el, {
      backdrop: true,
      keyboard: true,
    });
    inst.show();
    return;
  }

  // Fallback (no Bootstrap JS)
  el.classList.add("show");
  el.style.display = "block";
  el.removeAttribute("aria-hidden");
  el.setAttribute("aria-modal", "true");
  el.setAttribute("role", "dialog");
  document.body.classList.add("modal-open");
};

export const hideModal = (id: string) => {
  const el = document.getElementById(id);
  if (!el) return;

  if (window.bootstrap?.Modal) {
    const inst = window.bootstrap.Modal.getOrCreateInstance(el);
    const onHidden = () => {
      el.removeEventListener("hidden.bs.modal", onHidden);
      cleanupModals();
    };
    el.addEventListener("hidden.bs.modal", onHidden);
    inst.hide();
    return;
  }

  // Fallback (no Bootstrap JS)
  el.classList.remove("show");
  el.style.display = "none";
  el.setAttribute("aria-hidden", "true");
  el.removeAttribute("aria-modal");
  el.removeAttribute("role");
  cleanupModals();
};

export const swapModals = (fromId: string, toId: string) => {
  hideModal(fromId);
  setTimeout(() => showModal(toId), 140);
};

/** Optional: call once at app root (or Header) to ensure cleanup after any Bootstrap modal hides */
export const attachGlobalModalCleanup = () => {
  const handler = () => cleanupModals();
  document.addEventListener("hidden.bs.modal", handler);
  return () => document.removeEventListener("hidden.bs.modal", handler);
};
